/**
 * Available LaunchDarkly flags to evaluate
 */
export interface LaunchDarklyFlags {
  flags?: {
    /**
     * Flag for testing the LD integration
     */
    uiTest: boolean;
    managedApps: boolean;
    evalService: boolean;
    oktaIntegration: boolean;
    intuneIntegration: boolean;
    hexnodeIntegration: boolean;
    applicationListWidgets: boolean;
    applicationBinarySubmit: boolean;
    ivantiIntegration: boolean;
    newPdfReport: boolean;
    workspaceOneIntegration: boolean;
    sentinelIntegration: boolean;
    iosSbom: boolean;
    guardianReportThreatScore: boolean;
    dashboardV2: boolean;
    qscoutByokAi: boolean;
  };
}

export function isQscoutByokAiEnabled(flags?: LaunchDarklyFlags['flags']): boolean {
  if (process.env.QSCOUT_BYOK_AI_ENABLED === 'true') {
    return true;
  }
  return Boolean(flags?.qscoutByokAi);
}
